module.exports = __webpack_public_path__ + "static/media/61-mercedes.72f9310e.jpg";